import { selectIsPublishButtonPending } from '.';
import { IAppState } from '../../redux';
import { selectIsSaveDraftPending } from '../draft';
import { selectServiceUnavailableReason } from '../publishTerms';

export function selectIsPublishButtonDisabled(state: IAppState): boolean {
  const isPublishButtonPending = selectIsPublishButtonPending(state);
  const isSaveDraftPending = selectIsSaveDraftPending(state);
  const unavailableReason = selectServiceUnavailableReason(state);

  return isPublishButtonPending || isSaveDraftPending || Boolean(unavailableReason);
}
